import { render, staticRenderFns } from "./SecondFooter.vue?vue&type=template&id=6f5a2d6a&scoped=true"
import script from "./SecondFooter.vue?vue&type=script&lang=js"
export * from "./SecondFooter.vue?vue&type=script&lang=js"
import style0 from "./SecondFooter.vue?vue&type=style&index=0&id=6f5a2d6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a2d6a",
  null
  
)

export default component.exports